/* Aure Reviews carousel — vanilla ES6, IIFE
   Auto-advances slides one at a time. Loops infinitely.
   Pause on hover / focus / when tab is hidden. */
(function () {
  'use strict';

  function initCarousel(root) {
    if (!root || root.dataset.aureRsInit === '1') return;
    root.dataset.aureRsInit = '1';

    var track = root.querySelector('[data-aure-rs-track]');
    var viewport = root.querySelector('[data-aure-rs-viewport]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-aure-rs-slide]')) : [];
    var prevBtn = root.querySelector('[data-aure-rs-prev]');
    var nextBtn = root.querySelector('[data-aure-rs-next]');
    var progress = root.querySelector('[data-aure-rs-progress]');

    if (!track || slides.length <= 1) return;

    var index = 0;
    var autoplayMs = (parseInt(root.dataset.autoplay, 10) || 5) * 1000;
    var progressRaf = null;
    var progressStart = 0;
    var paused = false;

    function stepWidth() {
      var first = slides[0];
      var second = slides[1] || first;
      var rect1 = first.getBoundingClientRect();
      var rect2 = second.getBoundingClientRect();
      return Math.round(rect2.left - rect1.left) || rect1.width;
    }

    function visibleCount() {
      var vw = viewport.getBoundingClientRect().width;
      var w = stepWidth();
      if (!w) return 1;
      return Math.max(1, Math.round(vw / w));
    }

    function maxIndex() {
      return Math.max(0, slides.length - visibleCount());
    }

    function clamp(i) {
      var max = maxIndex();
      if (i < 0) return max;
      if (i > max) return 0;
      return i;
    }

    function apply() {
      var x = index * stepWidth();
      track.style.transform = 'translateX(' + (-x) + 'px)';
    }

    function go(delta) {
      index = clamp(index + delta);
      apply();
      resetProgress();
    }

    function tickProgress(ts) {
      if (paused) {
        progressRaf = requestAnimationFrame(tickProgress);
        return;
      }
      if (!progressStart) progressStart = ts;
      var elapsed = ts - progressStart;
      var pct = Math.min(100, (elapsed / autoplayMs) * 100);
      if (progress) progress.style.width = pct + '%';
      if (elapsed >= autoplayMs) {
        index = clamp(index + 1);
        apply();
        progressStart = ts;
        if (progress) progress.style.width = '0%';
      }
      progressRaf = requestAnimationFrame(tickProgress);
    }

    function resetProgress() {
      progressStart = 0;
      if (progress) progress.style.width = '0%';
    }

    function start() {
      if (progressRaf) return;
      progressStart = 0;
      progressRaf = requestAnimationFrame(tickProgress);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });

    document.addEventListener('visibilitychange', function () {
      paused = document.hidden;
    });

    var resizeRaf;
    window.addEventListener('resize', function () {
      cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function () {
        index = clamp(index);
        apply();
      });
    });

    var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (rm && rm.matches) {
      return;
    }

    start();
  }

  function initAll() {
    var els = document.querySelectorAll('[data-aure-rs-carousel]');
    els.forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
